<template>
  <div class="member-handbook-page">
    <div v-html="richText"></div>
  </div>
</template>

<script>
import requestApi from '@/service';

export default {
  data() {
    return {
      richText: '',
    };
  },
  activated() {
    this.getRichText();
  },
  methods: {
    getRichText() {
      requestApi('/v3/api/admin/moreinfo/').then(res => {
        this.richText = res.auto_renew;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.member-handbook-page {
  padding: 30px;
}
</style>
